/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";
import { RadioGroup, Radio } from "@common/AggregationComponent";

const OutfitTabCategoryFilter = (props: any) => {
  const { genders, selectedGender, selectedHeight, onChangeSelected } = props;

  const { t } = useTranslation();

  return (
    <>
      <div>
        <RadioGroup
          columnCount={{ sm: 2, md: 2, lg: 2 }}
          legend={t("text_gender")}
        >
          {genders.map((gender: any) => (
            <Radio
              checked={gender.name === selectedGender}
              id={`outfit-tab-new-filter-height-gender-${gender.id}`}
              key={`outfit-tab-new-filter-${gender.id}`}
              label={gender.name}
              name="outfit-tab-new-filter-gender-radio"
              onChange={() => {
                onChangeSelected(gender.name, selectedHeight, true);
              }}
              value={`outfit-tab-new-filter-${gender.id}`}
            />
          ))}
        </RadioGroup>
      </div>
    </>
  );
};
export default OutfitTabCategoryFilter;
